var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i-head",style:({background:_vm.config.background, borderBottom:_vm.config.border})},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.config.logo,"alt":"logo"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }